import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { renderField, required, number, positiveNumber } from '../../../forms';
import TextEditor from './TextEditor';
const brandtest = {1:"one",2:"two",3:"threwee",4:"four"}
const brands = [1,2,3,4]
export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    
    <FormControl {...input} type={type} />
  </InputGroup>
);
//debugger

 let colourOptionsDemo = [
   { value: '1', label: 'Chocolatess' },
   { value: '2', label: 'Strawberry' },
   { value: '3', label: 'Vanilla' }
 ]

function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: item.label,
    value: item.value,
  }));
}

function handleInputChange(value) {
  //debugger;
  value.value
  
}

const SelectInput = ({
  input,
  options,
  name,
  id,
  label,
  help,
  meta: { active, touched, error, warning },
}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={value => {
        input.onChange(value.value);
      }}
      onBlur={value => input.onBlur(value.value)}
      joinValues
      isMulti
    />
    {help && <HelpBlock>{help}</HelpBlock>}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);

const RenderSelectInput = ({input, options, name, id, label, help, placeholder, meta: { active, touched, error, warning }}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => {
        const values = value.map(v => v.value);
        input.onChange(values);
      }}
      onBlur={(value) => input.onBlur(value.value)}
      multi
      joinValues
      placeholder={placeholder}
      //StylesConfig={styleConfig}
    />
    {(help && <HelpBlock>{help}</HelpBlock>)}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);

let colourOptions = [];
let dataTemp = [];

const HotelRoomPrefsForm = ({ onSubmit, initialValues,tour,onChange,onBlur}) => (
  
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    tour={tour}
    validate={values => {
      //const brand = values.members_data[0]
      
      const errors = {};
      if (!values.hotel_prefs.suites && !values.hotel_prefs.kings && !values.hotel_prefs.queens) {
        errors.FORM_ERROR = 'At least one room is required';
        
      }
            
      //colourOptions = formatContactData(values.data)
      dataTemp = values.data
      //debugger;     
      if (values.hotel_prefs.suites) {
        if (isNaN(values.hotel_prefs.suites)) {
          errors.suites = 'Must be a number';
        } else if (values.hotel_prefs.suites < 0) {
          errors.suites = 'Must be a postive number';
        }
      }
      if (values.hotel_prefs.kings) {
        if (isNaN(values.hotel_prefs.kings)) {
          errors.kings = 'Must be a number';
        } else if (values.hotel_prefs.kings < 0) {
          errors.kings = 'Must be a postive number';
        }
      }
      if (values.hotel_prefs.queens) {
        if (isNaN(values.hotel_prefs.queens)) {
          errors.queens = 'Must be a number';
        } else if (values.hotel_prefs.queens < 0) {
          errors.queens = 'Must be a postive number';
        }
      }
      return errors;
    }
    
  }


    //debugger
    render={({ handleSubmit, reset, submitting, pristine, errors,onChange,onBlur,options }) => (
  
      <form onSubmit={handleSubmit}>
        <div className="col-sm-10">
          <FormGroup>
            <Field
              name="hotel_prefs.note_json"
              type="textarea"
              component={TextEditor}
              label="Bid Details"
              placeholder="Lodging requests for this group. This note will be included in all tour stops."
            />
            <HelpBlock>
              Lodging requests for this group. This note will be included in all tour stops. 
            </HelpBlock>
          </FormGroup>
        </div>
        
        <div className="col-sm-3">
          <FormGroup>
            <Field
              name="hotel_prefs.suites"
              type="text"
              component={renderBootstrapField}
              label="Suites"
              placeholder="#"
            />
            
          </FormGroup>
        </div>
        
        <div className="col-sm-3">
          <FormGroup>
            <Field name="hotel_prefs.kings" component={renderBootstrapField} label="Kings" />
          </FormGroup>
        </div>
        <div className="col-sm-3">
          <FormGroup>
            <Field name="hotel_prefs.queens" component={renderBootstrapField} label="Doubles" />
          </FormGroup>
        </div>
        <div> 
         <Field
          name="Members_list_suites"
          //type="text"
          component={RenderSelectInput}
          placeholder="Members"
          label="Member List"
          options={dataTemp}
          
        />

      <Field
          name="Members_list_king"
          //type="text"
          component={RenderSelectInput}
          placeholder="Members"
          label="Member List"
          options={dataTemp}
          
        />

      <Field
          name="Members_list_queens"
          //type="text"
          component={RenderSelectInput}
          placeholder="Members"
          label="Member List"
          options={dataTemp}
          
        />
        {/* <FormGroup>
          <Field
            label="To"
            name="contacts"
            component={RenderSelectInput}
            options={options}
            placeholder="Select previously added contact for this hotel"
          />
        </FormGroup> */}
          {/* <FormGroup controlId="Member_List">
            <ControlLabel>Member List</ControlLabel>
            <Select options={colourOptions} 
              //onChange={handleInputChange}
              //blurInput={() => field.blurInput(field.value)}
              //onInputBlur={handleBlur}
              onCloseResetsInput={false}
              onBlurResetsInput={false}
              value={colourOptions}
              onBlur={(value) => input.onBlur(value.value)}
              
            />  
            {/* <Select
            id="portf"
            options={colourOptions}
            value={this.state.opts1}
            onChange={value => this.setState({ opts1: value })}
            placeholder="Select Portfolio" /> 
            </FormGroup>
            */}
        
          
        </div>     
        <div className="col-sm-9">
          {errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
          {errors.suites && <p className="alert alert-danger">{errors.suites}</p>}
          {errors.kings && <p className="alert alert-danger">{errors.kings}</p>}
          {errors.queens && <p className="alert alert-danger">{errors.queens}</p>}
          <FormGroup>
            <ButtonToolbar>
              <Button disabled={pristine || submitting} bsStyle="success" type="submit">
                <i className="fa fa-pencil fa-lg" /> Save
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </div>
      </form>
    )}
  />
);


export default HotelRoomPrefsForm;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelRoomPrefsForm.js